import { useQuery } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const GetCardContext = createContext(null);

type Props = {
  children: ReactElement;
};

const GetCardProvider: FunctionComponent<Props> = ({ children }) => {
  const { data, isLoading, error, isFetching } = useQuery({
    queryKey: ["payment_cards"],
    staleTime: 30000,
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(`billings/cards`);

      return data;
    },
  });

  const contextValue = useMemo(
    () => ({
      data,
      isLoading,
      isFetching,
    }),
    [isLoading, data, error, isFetching],
  );
  return (
    <GetCardContext.Provider value={contextValue}>
      {children}
    </GetCardContext.Provider>
  );
};

export default GetCardProvider;
